



import { Component, Vue } from 'vue-property-decorator';
@Component({
	name: 'indexLibrary',
})
export default class indexLibrary extends Vue {}
